var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortIcon = function SvgSortIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    viewBox: "0 0 6 10"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DADADA",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 6-3 4-3-4zM0 4l3-4 3 4z"
  }))));
};
export default SvgSortIcon;